import type { FC } from 'react';

import type { ElectoralCodeLevel } from '../helper';

const LABELS: Record<ElectoralCodeLevel, string> = {
	state: 'STATE',
	lga: 'LGA',
	ward: 'WARD',
	pollingUnit: 'PU',
};

interface LevelBadgeProps {
	level: ElectoralCodeLevel;
}

export const LevelBadge: FC<LevelBadgeProps> = ({ level }) => (
	<span
		className={`code-chip__level code-chip__level--${level}`}
		aria-label={`${LABELS[level]} code`}
	>
		{LABELS[level]}
	</span>
);
